
import { Component, Vue } from "vue-property-decorator";
import IngenieriaItem from "./IngenieriaItem.vue";

@Component({
  components: {
    IngenieriaItem
  }
})
export default class IngenieriaEstructuras extends Vue {
  
  frame = "LINEA_2_6_ingenieria_estru.png";

  texto = `- Puentes.
          <br/>
          - Pasarelas.
          <br/>
          - Túneles y Falsos Túneles.
          <br/>
          - Enlaces.
          <br/>
          - Hincas.
          <br/>
          - Obras de Fábrica, cajones.
          <br/><br/>
          <span class="texto-rojo">[ver fotos]</span>`;

}
